export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";